// extracted by mini-css-extract-plugin
export default {"actions":"training-games_actions__8HfLL"};